import {
  landingDescription,
  landingFeatures,
  landingTitle,
  periodLabel,
} from "./landingPlanCopy";
import { detailsHref, productSlug } from "./landingPlanHref";
import { selectLandingProducts } from "./landingPlanSelect";
import type { LandingCatalogProduct, LandingPlan } from "./landingPlanTypes";

/**
 * Select at most three landing plans from a raw product catalog.
 *
 * Eligibility, order, and the single Mais popular mark are
 * `selectLandingProducts`. Description, the first three features, the
 * remainder, the unchanged title, and the period word come only from the
 * product (`landingPlanCopy`). The details href uses the same slug as
 * `/planos`, and omits `plano` when that slug is empty or shared by two
 * products in this payload (`landingPlanHref`).
 *
 * One or two eligible products produce one or two results. The list is not
 * padded. This function does not call `fromProduct`, `usePlans`, or
 * `PlansRepository.getAll`.
 */
export function pickLandingPlans(
  products: readonly LandingCatalogProduct[] | null | undefined,
): LandingPlan[] {
  const selected = selectLandingProducts(products);
  return selected.map((plan) => {
    const listed = landingFeatures(plan.features);
    const slug = productSlug(plan.title);
    return {
      id: plan.id,
      title: landingTitle(plan.title),
      description: landingDescription(plan.description),
      price: plan.price,
      periodLabel: periodLabel(plan.amountOfDays),
      features: listed.features,
      featureRemainder: listed.featureRemainder,
      popular: plan.popular,
      slug,
      href: detailsHref(slug, products),
    };
  });
}

export { periodLabel };
export { detailsHref, productSlug };
export type { LandingCatalogProduct, LandingPlan };
